import { UserLocation } from '../_UserLocation';
import MapDataService from '../services/MapDataService';
import MAP_DATA from '../../_json/_map_data.json';

class MapEventHandlers
{
    constructor({
        openHomeModal,
        openMenuModal,
        openInfoModal,
        openStampcardModal,
        setModalLegendsOpened,
        setAutoCenter,
        setBFMap,
        hideTargetPin,
        setMapAlertData,
        setModalMapAlertOpened,
        bfMapState,
        stampcardOpened,
        isSelectedPin
    })
    {
        this.openHomeModal = openHomeModal;
        this.openMenuModal = openMenuModal;
        this.openInfoModal = openInfoModal;
        this.openStampcardModal = openStampcardModal;
        this.setModalLegendsOpened = setModalLegendsOpened;
        this.setAutoCenter = setAutoCenter;
        this.setBFMap = setBFMap;
        this.hideTargetPin = hideTargetPin;
        this.setMapAlertData = setMapAlertData;
        this.setModalMapAlertOpened = setModalMapAlertOpened;
        this.bfMapState = bfMapState;
        this.stampcardOpened = stampcardOpened;
        this.isSelectedPin = isSelectedPin;
    }

    handleUIBtnClick = (btnKey, map) =>
    {
        switch (btnKey)
        {
            case 'home':
                this.openHomeModal({}, { from:'map' });
                break;
            case 'menu':
                this.openMenuModal({}, { from:'map' });
                break;
            case 'legends':
                this.setModalLegendsOpened(true);
                break;
            case 'map-center':
                this.setAutoCenter(true);
                this.updateUserPosition();
                break;
            case 'zoom-in':
                map.zoomIn();
                break;
            case 'zoom-out':
                map.zoomOut();
                break;
            case 'handicap':
                const bfValue = !this.bfMapState;
                this.setBFMap(bfValue);
                break;
            case 'target-pin':
                this.hideTargetPin();
                break;
            case 'stampcard':
                if (!this.stampcardOpened)
                {
                    // Import StampUtils here to avoid circular dependencies
                    import('../_StampUtils').then(({ default: StampUtils }) =>
                    {
                        StampUtils.markStampsViewed();
                        // Note: setHasNewStamp(false) should be handled in the parent component
                        this.openStampcardModal({}, { from: 'map' });
                    });
                }
                break;
            default:
                break;
        }
    };

    handlePinClick = (type, id) =>
    {
        if (type === 'site' || type === 'food' || type === 'exterior')
        {
            this.openInfoModal(type, id);
        }
        else if (type === 'attention')
        {
            this.handleOpenAlertModal(id);
        }
        else if (type === 'construction')
        {
            this.handleOpenConstructionModal(id);
        }
    };

    updateUserPosition = () =>
    {
        UserLocation.getInstance().updateUserLocation();
    };

    handleOpenAlertModal = (key) =>
    {
        this.setModalMapAlertOpened(true);

        const item = MAP_DATA.cautions.find((e) => e.key === key);
        this.setMapAlertData(item);
    };

    handleOpenConstructionModal = (key) =>
    {
        this.setModalMapAlertOpened(true);

        const item = MAP_DATA.constructions.find((e) => e.key === key);

        this.setMapAlertData({
            ...item,
            img: 'icon_construction_l.png',
            className: 'construction'
        });
    };

    handleOpenInfoModal = (infoType, id, modalIndex = -1) =>
    {
        let data;
        
        if (infoType === 'site')
            data = MapDataService.getSiteData(id);
        else if (infoType === 'exterior')
            data = MapDataService.getExteriorData(id);
        else if (infoType === 'food')
            data = MapDataService.getFoodData(id);

        if (!data) return;

        data.type = infoType;

        if (this.isSelectedPin(infoType, id))
        {
            this.hideTargetPin();
        }

        return data;
    };

    // Update methods for dynamic state changes
    updateBFMapState(newBfMapState)
    {
        this.bfMapState = newBfMapState;
    }

    updateStampcardOpened(newStampcardOpened)
    {
        this.stampcardOpened = newStampcardOpened;
    }
}

export default MapEventHandlers; 